export const defaultEditableDate = function () {
  return {
    day: '',
    month: '',
    year: '',
    isBCE: false,
  }
}
